class Year {
    constructor({ resources = [] }) {
      this.years = resources;
    }
  }
  
  export default Year;